import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    ChangeLocaleAction,
    TranslationActionTypes
} from './translation.actions';
import { switchMap, catchError } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { MessageService } from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class TranslationEffects {
    changeLocale$ = createEffect(() =>
        this.actions$.pipe(
            ofType(TranslationActionTypes.CHANGE_LOCALE),
            switchMap((action: ChangeLocaleAction) => {

                if (!navigator.onLine) {
                    this.messageService.add({
                        severity: 'error',
                        detail: this.translateService.instant('CHANGE_LANGUAGE_OFFLINE_ERROR')
                    });
                    return EMPTY;
                }

                return this.translationService.downloadAndUse(action.payload.locale).pipe(
                    catchError(error => {
                        console.error('Error changing locale:', error);
                        return of(void 0);
                    })
                );
            })
        ),
        { dispatch: false }
    );

    constructor(
        private readonly actions$: Actions,
        private readonly translationService: TranslationService,
        private readonly messageService: MessageService,
        private readonly translateService: TranslateService

    ) {}
}

